import { GENERAL_LOADER, IS_NOTIFICATION_ARRIVES, NOTIFICATION_CLEAR, NOTIFICATION_TRIGGER, SET_CHAT_CHANNEL_ID, SET_NOTIFICATION_COUNT } from "../constants";

export default class GeneralActions {
    static TriggerNotification(payload) {
        return {
            type: NOTIFICATION_TRIGGER,
            payload
        }
    }

    static ClearNotifications() {
        return {
            type: NOTIFICATION_CLEAR
        }
    }

    static SetNotificationCount(payload) {
        return {
            type: SET_NOTIFICATION_COUNT,
            payload
        }
    }

    static SetChatChanneId(payload) {
        return {
            type: SET_CHAT_CHANNEL_ID,
            payload
        }
    }

    static SetCustomLoading(payload) { 
        return {
            type: GENERAL_LOADER,
            payload
        }
    }

}